export interface LinkShortenerSettings {
  linkShortenerSubdomain?: string | null;
  linkShortenerOmitProtocol?: boolean | null;
}

/** Drops `https://` from a short link for teams saving SMS characters. */
export function formatSmsShortLink(
  url: string,
  omitProtocol: boolean | null | undefined,
): string {
  return omitProtocol ? url.replace(/^https:\/\//, "") : url;
}

/** A short link as the team's SMS recipients would see it, for previews and length estimates. */
export function getShortenedLinkPreviewUrl(
  settings: LinkShortenerSettings | null | undefined,
  code: string,
): string {
  const host = settings?.linkShortenerSubdomain
    ? `${settings.linkShortenerSubdomain}.redo.link`
    : "redo.link";
  return formatSmsShortLink(
    `https://${host}/${code}`,
    settings?.linkShortenerOmitProtocol,
  );
}
